import { convertObjectToArrayAndSort } from 'util/convertObjectToArray';

import { SimpleProjectApi } from 'api/SimpleProjectApi';
import { PieChart } from 'model/PieChart';
import { CompareGroup } from 'model/CompareGroup';
import { SubmitType } from 'model/SubmitType';

import { CompareGroupMapper } from './CompareGroupMapper';

export class PieChartMapper {
  constructor(private compareGroupMapper: CompareGroupMapper) {}

  deserializeCombine(entry: SimpleProjectApi.PieChartCombineEntry): PieChart {
    return {
      count: entry.count,
      value: entry.percentage,
      type: entry.type,
      label: entry.label,
    };
  }

  deserializeCompare(
    entry: SimpleProjectApi.PieChartCompareEntry,
    groups: { [key: number]: string },
    protections: { [key: number]: boolean }
  ): { label: string; type: SubmitType; groups: ReadonlyArray<CompareGroup> } {
    return {
      label: entry.label,
      type: entry.type,
      groups: convertObjectToArrayAndSort(entry.byGroup).map((group) =>
        this.compareGroupMapper.deserialize(group, groups, protections)
      ),
    };
  }
}
